import type {PermissionsRecordType} from '../permissions';

export const employeePermissions = {
  employeeRead: {
    resourceId: 'EMPLOYEE',
    actionId: 'READ',
    scopes: [],
  },
} satisfies PermissionsRecordType;
